import styled from 'styled-components';
import { theme } from '@Themes/themeOverriderFabric';
const { blackGray } = theme.palette;

export const MessageBody = styled.span({
    fontSize: 12,
    fontWeight: 400,
    color: blackGray,
    padding: '0px 7px'
});

export const Container = styled.div({
    display: 'flex',
    flexDirection: 'row',
    padding: 7
});
